module.exports = __webpack_public_path__ + "img/x-yuki-icon.efbff2b0.png";